module.exports = __webpack_public_path__ + "static/img/home_banner.7f01a9f6.png";